import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

// Show all readonly fields
export default buildFacetDesignOverride().override({ readonly: true }, { hidden: false });
